/**
 * components/hazard — Аюул мэдээлэх / зөрчил бүртгэх маягтын модулиуд.
 *
 * Дотроос ашиглах боломж:
 *   import HazardFormComposer from "src/components/hazard";
 *   import { MODE_CONFIGS, getModeConfig } from "src/components/hazard";
 *   import { PhotoSection, LocationSection } from "src/components/hazard";
 */

import HazardFormComposer from "./HazardFormComposer";

export { default as PhotoSection } from "./PhotoSection";
export { default as LocationSection } from "./LocationSection";
export { default as HazardTypeSection } from "./HazardTypeSection";
export { default as DescriptionSection } from "./DescriptionSection";
export {
  default as SeveritySection,
  SEV_ICON,
  DEFAULT_SEV,
} from "./SeveritySection";
export { default as WhoExposedSection } from "./WhoExposedSection";
export { default as DateSection } from "./DateSection";
export {
  default as InspectionLevelSection,
  INSPECTION_LEVELS,
  getInspectionLevel,
} from "./InspectionLevelSection";
export {
  default as InspectionTypeSection,
  INSPECTION_TYPES,
  getInspectionType,
  normalizeFaIcon,
  hydrateInspectionTypes,
} from "./InspectionTypeSection";
export { default as SaveBarSection } from "./SaveBarSection";
export { default as SourceIcon } from "./SourceIcon";
export { MODE_CONFIGS, MODE_KEYS, getModeConfig } from "./hazardModes";
export { Card, SectionTitle, iconForCategory, SEV_COLOR, PEOPLE_OPTIONS, RED, PAGE_BG, inputStyle } from "./common";

export default HazardFormComposer;
export { HazardFormComposer };
